import { useEffect, useState } from "react";
import SearchIcon from "../../../assets/icons/search-icon-black.svg";
import CrossIcon from "../../../assets/icons/cross-icon-gray.svg";
import {
  EventDTO,
  SPToBFIdMap,
  SportSlugById,
  getEventSlug,
  searchEvents,
  setCompetitionThunk,
  setExchEvent,
  useAppDispatch,
} from "@hypexone/uicore";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { SVLS_API_CLIENT } from "../../../App.utils";

interface HeaderSearchInputProps {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  setIsMobileSearchPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HeaderSearchInput: React.FC<HeaderSearchInputProps> = ({
  searchValue,
  setSearchValue,
  setIsMobileSearchPopupOpen,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [searchedEvents, setSearchedEvents] = useState<EventDTO[]>();

  const searchEventsData = async (searchValue: string) => {
    setSearchedEvents(await searchEvents(SVLS_API_CLIENT, searchValue));
  };

  useEffect(() => {
    if (searchValue) {
      searchEventsData(searchValue);
    }
  }, [searchValue]);

  const getCompetitionSlug = (competitionName: string) => {
    return competitionName
      ?.toLocaleLowerCase()
      .replace(/[^a-z0-9]/g, " ")
      .replace(/ +/g, " ")
      .trim()
      .split(" ")
      .join("-");
  };

  const handleEventChange = (event: EventDTO) => {
    const sportId = SPToBFIdMap[event?.sportId];
    const competitionId = event.competitionId?.split(":").join("_");

    dispatch(
      setCompetitionThunk({
        id: competitionId,
        name: event.competitionName,
        slug: getCompetitionSlug(event.competitionName),
      })
    );
    dispatch(
      setExchEvent({
        id: event.eventId,
        name: event.eventName,
        slug: event.eventSlug || "",
      })
    );
    console.log("search input event", {
      eventInfo: {
        sportId: sportId,
        competitionId: competitionId,
        eventId: event?.eventId,
      },
      routeParam: btoa(`${sportId}:${competitionId}:${event?.eventId}`),
    });
    navigate(
      event?.providerName?.toLowerCase() === "sportradar" &&
        event?.catId === "SR VIRTUAL"
        ? `/exchange_sports/virtuals/${
            SportSlugById[sportId]
          }/${getCompetitionSlug(event?.competitionName)}/${getEventSlug(
            event?.eventName
          )}/${btoa(`${sportId}:${competitionId}:${event?.eventId}`)}`
        : `/exchange_sports/${SportSlugById[sportId]}/${getCompetitionSlug(
            event?.competitionName
          )}/${getEventSlug(event?.eventName)}/${btoa(
            `${sportId}:${competitionId}:${event?.eventId}`
          )}`,
      {
        state: {
          homeTeam: event?.homeTeam,
          awayTeam: event?.awayTeam,
          openDate: event?.openDate,
        },
      }
    );
  };

  return (
    <div className="flex relative">
      <div className="block w-full">
        <div className="flex items-center gap-2">
          <div className="flex flex-1">
            <div className="absolute top-0 left-0 h-full flex justify-center items-center ml-2">
              <img
                loading="lazy"
                src={SearchIcon}
                alt="search-icon"
                className="w-3"
              />
            </div>

            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder=""
              className="pl-7 pr-2 py-1 rounded-[5px] h-[40px] md:h-[24px] text-md md:text-xs outline-none min-w-full lg:min-w-[300px] border md:border-0"
            />
          </div>

          <img
            src={CrossIcon}
            alt="cross-icon"
            className="h-[18px] w-[18px] md:hidden"
            onClick={() => setIsMobileSearchPopupOpen?.(false)}
          />
        </div>

        <div
          className={`flex flex-col max-h-[400px] overflow-auto z-50 bg-white text-black absolute ${
            searchValue ? "border border-black z-10 w-full" : ""
          }`}
        >
          {searchValue &&
            searchedEvents?.map((event, index) => (
              <div
                key={index}
                className="p-2 border-b border-[#ccc] cursor-pointer"
                onClick={() => {
                  handleEventChange(event);
                  setSearchValue("");
                  setIsMobileSearchPopupOpen?.(false);
                }}
              >
                <div className="flex justify-between">
                  <div className="text-[16px] font-black">
                    {event?.sportName}
                  </div>
                  <div className="text-[16px] ">
                    {moment(event?.openDate).format("DD/MM/YY hh:mm A")}
                  </div>
                </div>
                <div className="text-[15px] font-normal pt-1 max-w-72 text-wrap">
                  {event?.eventName}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default HeaderSearchInput;
